// extracted by mini-css-extract-plugin
export default {"container":"M1-z","heading":"N1-z","links":"O1-z","copy":"P1-z","subCopy":"Q1-z","linksLeft":"R1-z","linksCenter":"S1-z","linksRight":"T1-z","link":"U1-z","onlyLink":"V1-z"};